import { connect } from 'react-redux';
import { FeatureToggleProvider } from 'react-feature-toggles';

const mapStateToProps = state => ({
  featureToggleList: state.features
});

export default connect(mapStateToProps)(FeatureToggleProvider);
